/**
 * Constantes públicas de la landing.
 */

/**
 * URL de la app en Google Play. Sale del applicationId del mobile
 * (`com.tmario.fbalycmobile`). Usar en todos los CTA de descarga.
 */
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.tmario.fbalycmobile";
